import { useState } from "react";
import { notify } from "../../../common/Toast";
import Button from "../../../common/Button";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import Table from "../../../common/Table";
import Loader from "../../../common/Loader";
import { NalcoRateAPI } from "../../../utlis/apiService";

const NalcoMaster = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNalcoData, setIsNalcoData] = useState([]);

  const handleFetchNalcoRate = async () => {
    setLoading(true);
    try {
      const res = await NalcoRateAPI.getAllNalcoPrice();
      setIsNalcoData(res.data || []);
    } catch (error) {
      notify("Error fetching Nalco Rate", "error");
    }
    setLoading(false);
  };

  const handleFetchIngotRate = async () => {
    setLoading(true);
    try {
      const res = await NalcoRateAPI.getAllIngotPrice();
      setIsNalcoData(res.data || []);
    } catch (error) {
      notify("Error fetching Ingot Rate", "error");
    }
    setLoading(false);
  };

  const filteredData = isNalcoData.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5 mt-10">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            />
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              />
            )}
          </div>

          <div className="flex gap-3">
            <Button
              text="Show Nalco Rate"
              onClick={handleFetchNalcoRate}
              className="bg-orange text-black font-semibold text-md rounded-md p-2"
            />
            <Button
              text="Fetch Ingot Rate"
              onClick={handleFetchIngotRate}
              className="bg-primary text-white font-semibold text-md rounded-md p-2"
            />
          </div>
        </div>

        {loading ? (
          <Loader />
        ) : filteredData.length > 0 ? (
          <Table
            columns={[
              { key: "logDate", label: "Log Date" },
              { key: "productCode", label: "Product Code" },
              { key: "nalcoPrice", label: "Nalco Price" },
              { key: "fileName", label: "File Name" },
              //   {
              //     key: "fileName",
              //     label: "File Name",
              //     render: (value) =>
              //       value ? (
              //         <a
              //           href={value}
              //           target="_blank"
              //           rel="noopener noreferrer"
              //           className="text-blue-600 hover:text-blue-800"
              //         >
              //           View File
              //         </a>
              //       ) : (
              //         <span className="text-gray-400">No File</span>
              //       ),
              //   },
            ]}
            data={filteredData}
            showActions={false}
          />
        ) : (
          <div className="text-center text-gray-400 py-8">
            No data available
          </div>
        )}
      </div>
    </>
  );
};

export default NalcoMaster;
